import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BaseApiService } from '../../../core/api/base-api.service';
import type {
  ConfirmMappingPayload,
  ImportJob,
  ImportJobRowsResponse,
  ImportKind,
  ImportRowStatus,
} from './imports.types';

@Injectable({ providedIn: 'root' })
export class ImportsApiService extends BaseApiService {
  protected override readonly resourcePath = 'v1/revenue';
  private readonly rawHttp = inject(HttpClient);

  upload(kind: ImportKind, file: File) {
    const form = new FormData();
    form.append('file', file);
    return this.rawHttp.post<ImportJob>(
      `${environment.apiUrl}/v1/revenue/imports?kind=${kind}`,
      form,
      { withCredentials: true },
    );
  }

  listImports() {
    return this.get<{ data: ImportJob[] }>('imports');
  }

  getJob(id: string) {
    return this.get<ImportJob>(['imports', id]);
  }

  listRows(id: string, opts?: { status?: ImportRowStatus; page?: number; pageSize?: number }) {
    const params: Record<string, string | number> = {};
    if (opts?.status) params['status'] = opts.status;
    if (opts?.page) params['page'] = opts.page;
    if (opts?.pageSize) params['pageSize'] = opts.pageSize;
    return this.get<ImportJobRowsResponse>(['imports', id, 'rows'], {
      params: Object.keys(params).length ? params : undefined,
    });
  }

  rowsCsvUrl(id: string, status: ImportRowStatus = 'failed'): string {
    return `${environment.apiUrl}/v1/revenue/imports/${id}/rows.csv?status=${status}`;
  }

  confirmMapping(id: string, payload: ConfirmMappingPayload) {
    return this.put<ImportJob, ConfirmMappingPayload>(['imports', id, 'mapping'], payload);
  }

  cancel(id: string) {
    return this.put<ImportJob, Record<string, never>>(['imports', id, 'cancel'], {});
  }

  templateUrl(kind: ImportKind): string {
    return `${environment.apiUrl}/v1/revenue/imports/template?kind=${kind}`;
  }
}
